import React from 'react';
import './TableRow.scss';

const TableRow = ({ children, className }: { children: React.ReactNode, className?: string }) => {
    return (
        <tr
            className={`${className ?? ''} table-row `}
        >
            {children}
        </tr>
    );
};

export default TableRow;
